import { useState, useEffect } from "react";

export const useUserAgent = () => {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    if (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator?.userAgent)) {
      setIsMobile(true);
    }
  }, []);

  return Object.assign([isMobile], {
    isMobile,
  });
};

export default useUserAgent;
